<template>
  <div>
    <v-app>
      <v-alert
        elevation="5"
        title="שגיאה"
        :value="true"
        type="error"
        icon=""
        dismissible
        >
        אירעה שגיאה, ניתן לנסות לרענן את העמוד.
        <br />
        במידה והשגיאה נמשכת אנא צרו איתנו קשר.
      </v-alert>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  date() {
    return {
      error: null,
    }
  },
  mounted() {
    console.error(this.$store.getters.error)
    // Sentry.captureException(err); 
  },
  methods: {
    destroy() {
      this.$emit('showError', false)
    }
  },
};
</script>



// WEBPACK FOOTER //
// ErrorMessage.vue?2a448f52